import { render, staticRenderFns } from "./Stamps.vue?vue&type=template&id=66ce886d"
import script from "./Stamps.vue?vue&type=script&lang=js"
export * from "./Stamps.vue?vue&type=script&lang=js"
import style0 from "./Stamps.vue?vue&type=style&index=0&id=66ce886d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports